'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
import * as $j_mealorama$002e$002dStore from "./mealorama.-Store.js";
var $p;
/** @constructor */
function $c_Lmealorama_Store$() {
}
export { $c_Lmealorama_Store$ as $c_Lmealorama_Store$ };
$p = $c_Lmealorama_Store$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lmealorama_Store$;
/** @constructor */
function $h_Lmealorama_Store$() {
}
export { $h_Lmealorama_Store$ as $h_Lmealorama_Store$ };
$h_Lmealorama_Store$.prototype = $p;
$p.m = (function() {
  return "Store";
});
$p.aSx = (function(x$0) {
  var $x_1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$uJ(x$0.g(0));
  return new $j_mealorama$002e$002dStore.$c_Lmealorama_Store($x_1.l, $x_1.h, x$0.g(1), x$0.g(2), (!(!x$0.g(3))), (!(!x$0.g(4))));
});
var $d_Lmealorama_Store$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lmealorama_Store$, "mealorama.Store$", ({
  H1: 1,
  d: 1,
  e: 1
}));
export { $d_Lmealorama_Store$ as $d_Lmealorama_Store$ };
var $n_Lmealorama_Store$;
function $m_Lmealorama_Store$() {
  if ((!$n_Lmealorama_Store$)) {
    $n_Lmealorama_Store$ = new $c_Lmealorama_Store$();
  }
  return $n_Lmealorama_Store$;
}
export { $m_Lmealorama_Store$ as $m_Lmealorama_Store$ };
//# sourceMappingURL=mealorama.-Store$.js.map
